
      import CartFill from './cart-fill.vue'
      import type { App, Plugin } from 'vue'

      export const CartFillPlugin: Plugin = {
        install(app: App) {
          app.component('CartFill', CartFill)
        },
      }
      export { CartFill }
      